<template>
  <div class="container">
      <div class="contract mynextpay">
          <div class="header-top text-center">
              <img src="@/assets/img/hdsd/logo-top.png">
          </div>
          <h2 class="text-center magb20">PHẦN MỀM QUẢN LÝ NỘI BỘ</h2>
          <h2 class="text-center magb20">MY NEXTPAY </h2>
          <p class="text-center"><img  src="@/assets/img/hdsd/Picture27.png" class="maxwd65"></p>
          <div class="guide">
              <div id="accordion" class="accordion" v-viewer>
                  <div class="card">
                      <div class="card-header">
                          <a class="card-link collapsed" data-toggle="collapse" href="#c0">
                              I. GIỚI THIỆU
                          </a>
                      </div>
                      <div id="c0" class="collapse" data-parent="#accordion">
                          <div class="card-body">
                              <ul class="liststyle1 magb20">
                                  <li><span> My NextPay là gì?</span>
                                      <p class="magb20 line-height">My NextPay là phần mềm hỗ trợ cho các Chuyên viên
                                          tư vấn Giải
                                          pháp chuyển đổi
                                          số của NextPay và các cấp quản lý thực hiện công việc được thuận tiện hơn.
                                      </p>
                                      <p class="magb20">Ứng dụng bao gồm các tính năng :
                                      </p>
                                      <div class="d-flex justify-content-center">
                                        <img  src="@/assets/img/hdsd/Picture28.png">
                                      </div>
                                      <div>
                                          <ul>
                                              <li>Chấm công (Checkin/ Checkout)
                                              </li>
                                              <li>Tạo, quản lý, thông báo lịch làm việc với Merchant
                                              </li>
                                              <li>Quản lý danh sách Merchant của mình
                                              </li>
                                              <li>Theo dõi, báo cáo về công việc, tỷ lệ KPI v..v
                                              </li>
                                          </ul>
                                      </div>
                                  </li>
                                  <div>
                                      <div>
                                          <li>
                                              <span>Đối tượng sử dụng My NextPay là ai?
                                              </span>
                                              <ul>
                                                  <li>Các cấp quản lý
                                                  </li>
                                                  <li>Các chuyên viên tư vấn
                                                  </li>

                                              </ul>
                                          </li>
                                          <li>
                                              <span>Tại sao phải dùng My NextPay?

                                              </span>
                                              <ul>
                                                  <li>Quản lý nhân viên và công việc hiệu quả hơn

                                                  </li>
                                                  <li>Nâng cao năng suất làm việc

                                                  </li>
                                                  <li>Hỗ trợ xây dựng chiến lược cho từng nhân viên
                                                  </li>
                                              </ul>
                                          </li>
                                          <li>
                                              <span>Dùng My NextPay như thế nào?
                                              </span>
                                              <ul>
                                                  <li>Đối với nhân viên: Tải app My NextPay từ Apple Store hoặc Google
                                                      Play.

                                                  </li>
                                                  <li>Đối với cấp quản lý: Truy cập website
                                                      <em> https://my.nextpay.global</em>

                                                  </li>
                                                  <li>Tài khoản đăng nhập yêu cầu phải là email của Công ty.
                                                  </li>
                                              </ul>
                                          </li>
                                      </div>
                                      <div class="d-flex justify-content-center">
                                        <img  src="@/assets/img/hdsd/Picture29.png" style="max-width: 50%;">
                                      </div>
                                  </div>
                              </ul>
                          </div>
                      </div>
                  </div>
                  <div class="card">
                      <div class="card-header">
                          <a class="card-link collapsed" data-toggle="collapse" href="#c1">
                              II. ĐẶC ĐIỂM SẢN PHẨM
                          </a>
                      </div>
                      <div id="c1" class="collapse" data-parent="#accordion">
                          <div class="card-body">
                              <p class="text-center"><img  src="@/assets/img/hdsd/Picture30.png" class="maxwd65">
                              </p>

                          </div>
                      </div>
                  </div>
                  <div class="card">
                      <div class="card-header">
                          <a class="card-link collapsed" data-toggle="collapse" href="#c2">
                              <span class="ml-3"> 1. Chấm công </span>
                          </a>
                      </div>
                      <div id="c2" class="collapse" data-parent="#accordion">
                          <div class="card-body">
                              <div>
                                  <p class="text-center">
                                    <img  src="@/assets/img/hdsd/Picture31.png" class="maxwd65">
                                  </p>
                                  <ul class="form-style2 style">
                                      <li> Chỉ cần người dùng cài đặt địa điểm chấm công GPS thì dù ở bất kỳ đâu,
                                          người
                                          dùng cũng có thể thực hiện chấm công từ điện thoại cá nhân.
                                      </li>
                                      <li> Cấp quản lý sẽ theo dõi được chi tiết thời gian làm việc của nhân
                                          viên.
                                      </li>
                                      <li> Hệ thống báo cáo đi muộn về sớm giúp quản lý nắm được chi tiết thời
                                          gian
                                          làm việc của nhân viên.
                                      </li>
                                  </ul>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="card">
                      <div class="card-header">
                          <a class="card-link collapsed" data-toggle="collapse" href="#c3">
                              <span class="ml-3"> 2. Quản lý Lịch làm việc</span>
                          </a>
                      </div>
                      <div id="c3" class="collapse" data-parent="#accordion">
                          <div class="card-body">
                              <div>
                                  <p class="text-center">
                                    <img  src="@/assets/img/hdsd/Picture32.png" class="maxwd65">
                                  </p>
                                  <ul class="form-style2 style">
                                      <li> Nhân viên chủ động tạo lịch làm việc để quản lý thời gian, kiểm soát khối
                                          lượng và tiến độ công việc với MC dễ dàng hơn.

                                      </li>
                                      <li> Theo dõi được lịch các sự kiện liên tục để nắm được công việc mình sẽ phải
                                          làm trong thời gian tới.

                                      </li>
                                      <li> Nhân viên có thể cài đặt nhắc nhở lịch biểu theo thời gian. Lịch sẽ tự động
                                          được thông báo trên phần mềm.

                                      </li>
                                  </ul>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="card">
                      <div class="card-header">
                          <a class="card-link collapsed" data-toggle="collapse" href="#c4">
                              <span class="ml-3"> 3. Quản lý Nhân viên</span>
                          </a>
                      </div>
                      <div id="c4" class="collapse" data-parent="#accordion">
                          <div class="card-body">
                              <div>
                                  <p class="text-center">
                                    <img  src="@/assets/img/hdsd/Picture33.png" class="maxwd65">
                                  </p>
                                  <ul class="form-style2 style">
                                      <li> Quản lý chi tiết toàn bộ thông tin cá nhân như: họ và tên, email, số điện
                                          thoại, vị trí
                                      </li>
                                      <li> Quản lý nhân viên ở trạng thái thử việc hay chính thức
                                      </li>
                                      <li>Quản lý chi tiết từng nhân sự thuộc quản lý trực tiếp là ai? Quản lý vùng là
                                          ai? Thuộc vùng nào?

                                      </li>
                                      <li>Có thể nhập - xuất ra file để dễ dàng tìm kiếm và quản lý
                                      </li>
                                  </ul>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="card">
                      <div class="card-header">
                          <a class="card-link collapsed" data-toggle="collapse" href="#c5">
                              <span class="ml-3"> 4. Quản lý thông tin Merchant</span>
                          </a>
                      </div>
                      <div id="c5" class="collapse" data-parent="#accordion">
                          <div class="card-body">
                              <div>
                                  <p class="text-center">
                                    <img  src="@/assets/img/hdsd/Picture34.png" class="maxwd65">
                                  </p>
                                  <ul class="form-style2 style">
                                      <li>Đa dạng trong việc tạo mới và lưu trữ thông tin Merchant: Họ và tên, số điện
                                          thoại, email, tên cửa hàng, ngành hàng, dịch vụ, địa điểm, bản đồ MC, ảnh
                                          mặt tiền MC,…

                                      </li>
                                      <li> Lưu trữ thông tin khách hàng tập trung ngay trên phần mềm, phục vụ cho việc
                                          tìm kiếm dễ dàng và hiệu quả.

                                      </li>
                                      <li>Dễ dàng tìm kiếm và xuất file Excel theo các tiêu chí: vùng, ngành hàng,
                                          dịch vụ,…
                                      </li>
                                      <li>Theo dõi tiến trình chăm sóc để chăm sóc MC một cách hiệu quả
                                      </li>
                                      <li>Quản lý hợp đồng một cách chính xác để kịp thời thẩm định cho MC
                                      </li>
                                  </ul>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="card">
                      <div class="card-header">
                          <a class="card-link collapsed" data-toggle="collapse" href="#c6">
                              <span class="ml-3">5. Đồng bộ trên nhiều thiết bị </span>
                          </a>
                      </div>
                      <div id="c6" class="collapse" data-parent="#accordion">
                          <div class="card-body">
                              <div>
                                  <p class="text-center">
                                    <img  src="@/assets/img/hdsd/Picture35.png" class="maxwd65">
                                  </p>
                                  <ul class="form-style2 style">
                                      <li>Ứng dụng công nghệ điện toán đám mây hiện đại mọi dữ liệu công việc đều được
                                          lưu trữ lên hệ thống. Nhân viên có thể làm việc mọi lúc mọi nơi.

                                      </li>
                                      <li> Quản lý tập trung dữ liệu cho phép đồng bộ dữ liệu trên nhiều thiết bị:
                                          Điện thoại, máy tính bảng, và máy tính.
                                      </li>
                                  </ul>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="card">
                      <div class="card-header">
                          <a class="card-link collapsed" data-toggle="collapse" href="#c7">
                              <span class="ml-3"> 6. Thông báo</span>
                          </a>
                      </div>
                      <div id="c7" class="collapse" data-parent="#accordion">
                          <div class="card-body">
                              <div>
                                  <p class="text-center">
                                    <img  src="@/assets/img/hdsd/Picture36.png" class="maxwd65">
                                  </p>
                                  <ul class="form-style2 style">
                                      <li>Tự động nhắc nhở lịch làm việc của nhân viên
                                      </li>
                                      <li> Cài đặt tuỳ biến các trạng thái tiến trình công việc: đánh dấu đã xem, chưa
                                          xử lý, đã xử lý v..v
                                      </li>
                                      <li>Thông báo về tiến trình đạt KPI của từng nhân viên.
                                      </li>
                                      <li>Thông báo nội quy, quy chế, chính sách v..v
                                      </li>
                                  </ul>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="card">
                      <div class="card-header">
                          <a class="card-link collapsed" data-toggle="collapse" href="#c8">
                              <span class="ml-3"> 7. Công việc</span>

                          </a>
                      </div>
                      <div id="c8" class="collapse" data-parent="#accordion">
                          <div class="card-body">
                              <div>
                                  <p class="text-center">
                                    <img  src="@/assets/img/hdsd/Picture37.png" class="maxwd65">
                                  </p>
                                  <ul class="form-style2 style">
                                      <li>Thêm chi tiết các công việc, sửa đổi cập nhật các thay đổi công việc
                                      </li>
                                      <li> Thay đổi trạng thái các công việc

                                      </li>
                                      <li>Xoá các công việc chưa xử lý

                                      </li>
                                      <li>Sắp xếp các công việc được ưu tiên

                                      </li>
                                  </ul>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="card">
                      <div class="card-header">
                          <a class="card-link collapsed" data-toggle="collapse" href="#c9">
                              <span class="ml-3"> 8. Báo cáo</span>
                          </a>
                      </div>
                      <div id="c9" class="collapse" data-parent="#accordion">
                          <div class="card-body">
                              <div>
                                  <p class="text-center">
                                    <img  src="@/assets/img/hdsd/Picture38.png" class="maxwd65">
                                  </p>
                                  <ul class="form-style2 style">
                                      <li>Báo cáo chi tiết về MC, hợp đồng, tiến trình.

                                      </li>
                                      <li> Báo cáo về kết quả làm việc, KPI, trạng thái v…v
                                      </li>
                                      <li>Báo cáo chi tiết tình hình nhân sự thuộc vùng quản lý.

                                      </li>
                                      <li>Số hoá dữ liệu bằng các hình ảnh minh họa trực quan.
                                      </li>
                                  </ul>
                              </div>
                          </div>
                      </div>
                  </div>

              </div>
          </div>
      </div>
  </div>
</template>

<script>

export default {
  data () {
    return {
      options: {
        defaultWidth: '100%',
        defaultHeight: '100%'
      },
      style: {
        width: '100%'
      }
    }
  },
  methods: {
  },
  components: {
    
  }
}
</script>

<style scoped src="@/assets/css/style_hdsd.css">
</style>

<style scoped src="@/assets/css/bootstrap4.3.1.min.css">
</style>

<style scoped>
.container {
  padding-right: 0 !important;
  padding-left: 0 !important;
}
</style>
